<template>
  <div class="Loading-mask">
    <div id="lottie" ref="loading" class="loading__img"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import LoadingJSON from "../../cn-demo-assets/loadingCrystalBall.json";
export default {
  name: "loading",
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.loading,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: LoadingJSON,
    });
  },
};
</script>
<style lang="scss" scoped>
.Loading-mask {
  width: 100%;
  height: 100%;
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #393939;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  #lottie {
    // height: 80%;
    width: 400px;
  }
}
</style>
